// src/pages/Receive.js

import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useNavigate } from "react-router-dom";

import {
  CopyOutlined,
  ArrowLeftOutlined,
  CheckOutlined,
} from "@ant-design/icons";

import "../components/Walletview.css";
import "./Receive.css";
import { ArrowLeft } from "lucide-react";

const Receive = ({ wallet, logout, selectedChain, setSelectedChain }) => {
  const navigate = useNavigate();

  const [copied, setCopied] = useState(false);

  const walletAddress = wallet || "";

  // =========================================================
  // COPY WALLET ADDRESS
  // =========================================================

  const copyToClipboard = async () => {
    if (!walletAddress) {
      return;
    }

    try {
      await navigator.clipboard.writeText(walletAddress);

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Failed to copy:", err);

      const textArea = document.createElement("textarea");

      textArea.value = walletAddress;

      textArea.style.position = "fixed";
      textArea.style.left = "-9999px";
      textArea.style.top = "0";

      document.body.appendChild(textArea);

      textArea.focus();
      textArea.select();

      try {
        document.execCommand("copy");

        setCopied(true);

        setTimeout(() => {
          setCopied(false);
        }, 2000);
      } catch (fallbackError) {
        console.error("Fallback copy failed:", fallbackError);
      }

      document.body.removeChild(textArea);
    }
  };

  // =========================================================
  // FORMAT ADDRESS
  // =========================================================

  const formatAddress = (addr) => {
    if (!addr) {
      return "";
    }

    if (addr.length <= 12) {
      return addr;
    }

    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  // =========================================================
  // RETURN
  // =========================================================

  return (
    <div className="receive-page">
      {/* =================================================
          PAGE TITLE
      ================================================= */}

      <div className="receive-page-title">
        {/* BACK BUTTON */}
        <button
          type="button"
          className="market-back-btn"
          onClick={() => navigate("/yourwallet")}
          title="Back to Wallet"
        >
          <ArrowLeft size={18} />
        </button>

        <div>
          <h1
            style={{
              margin: 0,
              fontFamily: "'Inter', 'Poppins', 'Segoe UI', sans-serif",
              fontSize: "26px",
              fontWeight: 600,
              letterSpacing: "1.4px",
              lineHeight: 1.1,
              color: "#8a5a1f",
              WebkitTextStroke: "0.4px #6b3d0a",
              textShadow:
                "0 1px 0 rgba(255, 240, 200, 0.6), 0 2px 6px rgba(154, 106, 24, 0.22)",
            }}
          >
            Receive
          </h1>

          <p
            style={{
              margin: "4px 0 0",
              fontFamily: "'Poppins', 'Segoe UI', sans-serif",
              fontSize: "11px",
              fontWeight: 500,
              letterSpacing: "0.6px",
              lineHeight: 1.3,
              color: "#a07a3f",
              opacity: 0.95,
            }}
          >
            Receive BAIT and supported assets
          </p>
        </div>
      </div>

      {/* =================================================
          QR CODE
      ================================================= */}

      <div className="receive-qr-container">
        <div className="receive-qr-wrapper">
          <div className="receive-qr-code">
            {walletAddress ? (
              <QRCodeCanvas
                value={walletAddress}
                size={150}
                level="H"
                includeMargin={true}
                bgColor="#ffffff"
                fgColor="#1a1a2e"
              />
            ) : (
              <div className="receive-qr-placeholder">
                No address available
              </div>
            )}
          </div>

          <div className="receive-qr-label">Scan to receive</div>
        </div>
      </div>

      {/* =================================================
          WALLET ADDRESS
      ================================================= */}

      <div className="receive-address-section">
        <div className="receive-address-label">Your wallet address</div>

        <div className="receive-address-box">
          <code className="receive-address">
            {walletAddress || "No address available"}
          </code>

          <button
            className={`receive-copy-btn ${copied ? "copied" : ""}`}
            onClick={copyToClipboard}
            type="button"
            aria-label={copied ? "Address copied" : "Copy wallet address"}
            title={copied ? "Copied" : "Copy address"}
          >
            {copied ? <CheckOutlined /> : <CopyOutlined />}

            {copied ? " Copied!" : " Copy"}
          </button>
        </div>

        <div className="receive-address-short">
          {formatAddress(walletAddress)}
        </div>
      </div>

      {/* =================================================
          INFORMATION
      ================================================= */}

      <div className="receive-info">
        <p>
          ⚠️ Only send BAIT or supported tokens to this address.
        </p>

        <p>
          Sending other assets may result in permanent loss.
        </p>
      </div>
    </div>
  );
};

export default Receive;